import { createAuthClient } from "better-auth/vue";
import { inferAdditionalFields, magicLinkClient } from "better-auth/client/plugins";

// Same-origin: the Better Auth handler lives in this app's Nitro server.
// Better Auth is authentication-only after RU-4 — the organization domain moved
// to the Go contract (/organizations, /me, PUT /me/active-organization, …). We
// keep magic-link and declare the session's active organization (written by the
// Go side, read here for tenant scope + UI) via inferAdditionalFields, instead
// of the organization plugin's now-dead RPC surface.
export const authClient = createAuthClient({
  plugins: [
    magicLinkClient(),
    inferAdditionalFields({
      session: { activeOrganizationId: { type: "string", required: false } },
    }),
  ],
});

export function useAuth() {
  return authClient;
}

export const useSession = () => authClient.useSession();
